/**
 * `dev` and `ci` are the non-production build codes. Anything else (`staging`,
 * `production`, or an unset value in a real deploy) counts as a real environment
 * where analytics, conversions and dev-only integrations must behave normally.
 *
 * Optional-chaining on `import.meta.env`: Playwright loads some `~/lib` modules
 * under Node, where Vite has not defined `import.meta.env`.
 */
export function environmentCode(): string {
  return import.meta.env?.VITE_ENVIRONMENT_CODE ?? "";
}

export function isDevOrCiEnvironment() {
  const code = environmentCode();
  return code === "dev" || code === "ci";
}
